import IPRChart from "./IPRChart";

export const ChartsSection = () => {
	return <IPRChart />;
}